import { useEffect, useRef } from 'react';
import { changePhoneNumberDynamicallyAfterTimeout } from 'utils/InvocaUtils';
import { useBreakpoints } from 'hooks/useBreakpoints';

export function useInvocaRunByBreakpoints() {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);
  const { browser } = useBreakpoints();

  useEffect(() => {
    killTimeout();

    timeoutId.current = setTimeout(changePhoneNumberDynamicallyAfterTimeout);

    function killTimeout() {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    }

    return () => {
      killTimeout();
    };
  }, [browser.is.mobile, browser.is.desktop]);
}
